import { CLIENT_PORTAL_USER_STATUSES } from 'domain/shared/clientPortal';

export const ADD_NEW_CONTACT_OPTION_VALUE = 'ADD_NEW_CONTACT';

export const CLIENT_PORTAL_ENABLE_CONFIRMATION_MESSAGE = 'Do you want to enable client portal for this account?';

export const CLIENT_PORTAL_DISABLE_CONFIRMATION_MESSAGE = 'Do you want to disable client portal for this account?';

export const getClientPortalUserActionLabel = (status: string) =>
  status === CLIENT_PORTAL_USER_STATUSES.INVITED
    ? 'Revoke an invitation'
    : status === CLIENT_PORTAL_USER_STATUSES.INACTIVE
      ? 'Activate user'
      : 'Deactivate user';

export const getClientPortalUserConfirmationMessage = (status: string) =>
  status === CLIENT_PORTAL_USER_STATUSES.INVITED
    ? 'Do you want to revoke an invitation for this client?'
    : status === CLIENT_PORTAL_USER_STATUSES.INACTIVE
      ? 'Do you want to activate this client?'
      : 'Do you want to deactivate this client?';
